import {
  JOIN_MATCH,
  GET_MATCHES,
  GET_LIVE_MATCHES,
  GET_UPCOMING_MATCHES,
  GET_ARCHIVED_MATCHES,
  GET_MATCH_PLAYERS,
  GET_MATCH_SESSIONS,
  GET_SESSION_SEAT_DRAW,
  GET_PUBLIC_INFO,
  CREATE_MATCH,
  START_MATCH,
} from 'constants/actionTypes';
import Fetch from 'helpers/fetch';
import configs from 'configs';
import { openToaster } from '.';
import { generateUrlQuery } from 'helpers/generateUrlQuery';

const { MATCHES_API } = configs;

export const joinMatch = body => async (dispatch, getState) => {
  const { auth } = getState();
  const teamId = body.teamId;
  const account = auth?.user?.associatedAccounts?.find(
    acc => acc.skinId == teamId && acc.typeId == 1,
  );
  const payload = {
    playerId: body.playerId,
    joinId: `${body.joinId}_${teamId}`,
  };

  const res = await Fetch.POST(`/matchpoker/joinMatch`, {
    headers: {
      'x-access-token': account?.token,
      'Content-Type': 'application/json',
    },
    action: JOIN_MATCH,
    url: MATCHES_API,
    body: payload,
  });
  if (!res?.error) {
    return dispatch(
      openToaster({ type: 'success', content: 'You are successfully joined' }),
    );
  }
};

export const startMatch = body => async (dispatch, getState) => {
  const { auth } = getState();

  const res = await Fetch.POST(`/v1/matchTournamentControlAction`, {
    headers: {
      'x-access-token': auth?.user?.token,
      'Content-Type': 'application/json',
    },
    action: START_MATCH,
    url: MATCHES_API,
    body,
  });
  if (!res?.error) {
    return dispatch(
      openToaster({ type: 'success', content: 'You are successfully started' }),
    );
  }
};

const actiontypes = {
  upcoming: GET_UPCOMING_MATCHES,
  archived: GET_ARCHIVED_MATCHES,
  live: GET_LIVE_MATCHES,
};

export const fetchAllMatches = (status, sortBy) => async (dispatch, getState) => {
  const { auth } = getState();
  const matches = await Fetch.GET(
    `/matchpoker/getMatches?status=${status}&sortBy=${sortBy}`,
    {
      headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
      action: GET_MATCHES,
      url: MATCHES_API,
    },
  );
  if (matches)
    dispatch({
      type: actiontypes[status],
      payload: matches,
    });
};

export const fetchMatchPlayers = matchId => async (dispatch, getState) => {
  const { auth } = getState();
  const players = await Fetch.GET(`/matchpoker/getMatchPlayers?matchId=${matchId}`, {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    action: GET_MATCH_PLAYERS,
    url: MATCHES_API,
  });
  if (players)
    dispatch({
      type: GET_MATCH_PLAYERS,
      payload: players,
    });
};

export const updateSquad = (body, matchId) => async (dispatch, getState) => {
  const { auth } = getState();
  const res = await Fetch.POST(`/matchpoker/updateSquad`, {
    headers: {
      'x-access-token': auth.user?.token || localStorage.getItem('mpToken'),
      'Content-Type': 'application/json',
    },
    action: JOIN_MATCH,
    url: MATCHES_API,
    body,
  });
  if (!res?.error) {
    dispatch(fetchMatchPlayers(matchId));
    dispatch(
      openToaster({
        type: 'success',
        content: 'You have successfully updated the squad',
      }),
    );
  }
};

export const fetchMatchSessions = matchId => async (dispatch, getState) => {
  const { auth } = getState();
  const sessions = await Fetch.GET(`/matchpoker/getMatchSessions?matchId=${matchId}`, {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    action: GET_MATCH_PLAYERS,
    url: MATCHES_API,
  });
  if (sessions)
    dispatch({
      type: GET_MATCH_SESSIONS,
      payload: sessions,
    });
};

export const generateSessionSeatDraw = body => async (dispatch, getState) => {
  const { auth } = getState();
  const res = await Fetch.POST(`/matchpoker/generateSessionSeatDraw`, {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    action: GET_MATCH_PLAYERS,
    url: MATCHES_API,
    body,
  });
  if (!res?.error) {
    dispatch(
      openToaster({
        type: 'success',
        content: 'Seat Draw generated successfully',
      }),
    );
  }
};

export const fetchSessionSeatDraw =
  (matchId, sessionId) => async (dispatch, getState) => {
    const { auth } = getState();
    const result = await Fetch.GET(
      `/matchpoker/getSessionSeatDraw?matchId=${matchId}&sessionId=${sessionId}`,
      {
        headers: {
          'x-access-token': auth.user?.token || localStorage.getItem('mpToken'),
        },
        action: GET_MATCH_PLAYERS,
        url: MATCHES_API,
      },
    );
    if (result[0]?.sessionSeatDraw)
      dispatch({
        type: GET_SESSION_SEAT_DRAW,
        payload: result[0]?.sessionSeatDraw,
      });
  };

export const fetchPublicInfo = params => async (dispatch, getState) => {
  let url = generateUrlQuery(params);
  const { auth } = getState();
  const { result } = await Fetch.GET(`/getPublicInfo${url}`, {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    action: GET_PUBLIC_INFO,
  });
  if (result)
    dispatch({
      type: GET_PUBLIC_INFO,
      payload: result,
    });
};

export const createMatch = body => async (dispatch, getState) => {
  const { auth } = getState();
  const res = await Fetch.POST(`/v1/matches`, {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    action: CREATE_MATCH,
    url: MATCHES_API,
    body,
  });
  if (!res?.error && res?.message)
    return dispatch(openToaster({ type: 'success', content: res.message }));
};

export const registerToPoker = body => async (dispatch, getState) => {
  const { auth } = getState();
  const res = await Fetch.POST(`/v1/processMatchSessionSeating`, {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    url: MATCHES_API,
    body,
  });
  if (!res?.error) {
    return dispatch(
      openToaster({ type: 'success', content: res.message || 'Successfully registered' }),
    );
  }
};
